//codex-- Shared URL rules and exact PHP request contracts.
import axios from 'axios';
export function bookmarkTarget(value) {
  if (typeof value !== 'string') return null;
  const link = value.trim();
  // eslint-disable-next-line no-control-regex -- Explicitly reject control characters in stored navigation targets.
  if (!link || link.length > 2048 || /[\s\\\u0000-\u001f\u007f]/.test(link)) return null;
  if (link.startsWith('/') && !link.startsWith('//')) return { href: link, external: false };
  if (!/^https?:\/\//i.test(link)) return null;
  try {
    const url = new URL(link);
    return url.hostname && !url.username && !url.password ? { href: link, external: true } : null;
  } catch { return null; }
}
//codex-- Request only the site's standard icon, without passing bookmark paths/query strings to another service.
export function bookmarkIconUrl(link) {
  const target = bookmarkTarget(link);
  if (!target) return '';
  if (!target.external) return `${(process.env.PUBLIC_URL || '').replace(/\/$/, '')}/favicon.ico`;
  const icon = new URL('/favicon.ico', target.href);
  // Avoid mixed-content image requests when the application is served over HTTPS.
  icon.protocol = 'https:';
  return icon.href;
}
export const bookmarkError = (error) => error.response?.data?.message || error.message || 'Could not load bookmarks. Please try again.';
export async function bookmarkRequest(apiUrl, action, data = {}, id = null) {
  const response = action === 'getList'
    ? await axios.get(`${apiUrl}/bookmark_crud.php`, { params: { getList: true } })
    : await axios.post(`${apiUrl}/bookmark_crud.php`, { status: action, id, data }, { headers: { 'Content-Type': 'application/json' } });
  if (response.data?.success !== true) throw new Error(response.data?.message || 'Could not save bookmarks. Please try again.');
  return response.data;
}
